import { func, bool } from 'prop-types';
import { DaypickerIconNavigation, DaypickerNavigation } from './Styled';
const Navbar = ({
  onPreviousClick,
  onNextClick,
  showNextButton,
  showPreviousButton
}) => {
  const onPrev = () => onPreviousClick();
  const onNext = () => onNextClick();
  return /*#__PURE__*/React.createElement(DaypickerNavigation, null, /*#__PURE__*/React.createElement(DaypickerIconNavigation, {
    isDisabled: !showPreviousButton,
    onClick: onPrev
  }), /*#__PURE__*/React.createElement(DaypickerIconNavigation, {
    isDisabled: !showNextButton,
    onClick: onNext,
    isRight: true
  }));
};
Navbar.propTypes = {
  onPreviousClick: func,
  onNextClick: func,
  /* react-day-picker props */ // eslint-disable-next-line react/boolean-prop-naming
  showNextButton: bool,
  // eslint-disable-next-line react/boolean-prop-naming
  showPreviousButton: bool
};
export default Navbar;